import { atom } from 'nanostores';

/**
 * What the Marketplace panel should open next (set by storefront deep links;
 * the panel consumes and clears it). `source: 'storefront'` is sent with the
 * install and the analytics beacons for the listing it opens.
 */
export interface MarketplaceIntent {
  view: 'plugins' | 'experts' | 'wishlist';
  slug: string | null;
  expert: string | null;
  wishId: string | null;
  source: 'storefront';
}

export const $marketplaceIntent = atom<MarketplaceIntent | null>(null);
